export default __webpack_public_path__ + "static/media/home-candlelight.40b795dd.svg";